import { SET_ATTRIBUTES } from "../constants/actionTypes";

const attributes = (state = {}, action) => {
  switch (action.type) {
    case SET_ATTRIBUTES:
      return action.attributes;
    default:
      return state;
  }
};

export default attributes;
